const Gatekeeper = require('./src/gatekeeper');

module.exports = {Gatekeeper};
